/**
 * Setup script for websites
 *
 * @author Michel Heitbrink
 */
import Nutshell from './Nutshell';
import FormElements from './FormElements';
import Validator from './Validator';

class Setup {

    static getDefaults() {
		return {
            assign: {
                formElements: true,
                validator: true
            }
		}
	}

    static getName() {
        return 'Setup';
    }

    static init(options) {

        this.options = ( Nutshell.options.Setup ) ?  { ...Nutshell.options.Setup } : {};

        if ( options ) {
            this.options = { ...options };
        }

        /**
         * Assign Plugins weh page is loaded
         */
        document.addEventListener('DOMContentLoaded', () => {

            /**
             * Assign the validator to forms
             */
            if ( this.options.assign.validator ) {
                Validator.assign();
            }

            /**
             * Add javascript to inputs
             */
            if ( this.options.assign.formElements ) {
                FormElements.apply();
            }

        }, false);

    }
}

export default Setup;

/*
---
name: Setup
category: JavaScript
---

Adding default javascript to your website. Check the options which plugins are supported. If this class is called and initialized the classes FormElements and Validator can be ignored.

Initialize
======

```js
import { Setup } from '@nutshell/core';

Setup.init({
    assign: {
        formElements: true, //Add floating input support
        validator: true //Assign validation to your forms. See Validator documentation for more
    }
});
```

*/
